import { CompanyManagementUsersPermission } from './companyManagementTypes';
import { AddUserRequestDto } from '../../API/user-management/dto/request/add-user.request.dto';
import { UpdateUserRequestDto } from '../../API/user-management/dto/request/update-user.request.dto';

export const companyManagementAddNewUserDto = (
  data: CompanyManagementUsersPermission
): AddUserRequestDto => {
  return {
    email: data.email,
    full_name: data.fullName,
    company_token: data?.company_token,
    job_title: data.jobTitle,
    phone: data.phone,
  };
};

export const companyManagementUpdateUserDto = (
  data: CompanyManagementUsersPermission
): UpdateUserRequestDto => {
  return {
    email: data.email,
    full_name: data.fullName,
    company_token: data?.company_token,
    job_title: data.jobTitle,
    phone: data.phone,
  };
};
